import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("post", "/admin/login/adminLogin", params) };

// 权限菜单接口 
export const getMenu = (params) => { return req("post", "/admin/admin/getAdminPermission", params) };
// 按钮权限接口
export const getBtn = (params) => { return req("post", "/admin/admin/getAdminBtn", params) };
// 系统设置-账户列表(分页)
export const getAccountPageList = (params) => { return req("post", "/admin/admin/getAdminList", params) };
// 系统设置-添加账户
export const addAccount = (params) => { return req("post", "/admin/admin/addAccount", params) };
// 系统设置-编辑账户
export const editAccount = (params) => { return req("post", "/admin/admin/editAdmin", params) };
// 系统设置-重置密码
export const resetAccountPwd = (params) => { return req("post", "/admin/admin/resetAdminPwd", params) };
// 系统设置-角色列表(分页)
export const getRolePageList = (params) => { return req("post", "/admin/admin/getRoleList", params) };
// 系统设置-菜单列表(分页)
export const getMenuPageList = (params) => { return req("post", "/admin/admin/getMenuList", params) };
// 系统设置-菜单编辑
export const editMenu = (params) => { return req("post", "/admin/admin/editMenu", params) };
// 系统设置-菜单删除
export const delMenu = (params) => { return req("post", "/admin/admin/delMenu", params) };
// 系统设置-角色编辑
export const editRole = (params) => { return req("post", "/admin/admin/editRole", params) };
// 系统设置-获取所有权限
export const getAuthMenu = (params) => { return req("post", "/admin/admin/getAuthMenu", params) };
// 系统设置-获取角色权限详情
export const getRoleInfo = (params) => { return req("post", "/admin/admin/getRoleInfo", params) };
// 系统设置-删除角色
export const delRole = (params) => { return req("post", "/admin/admin/delRole", params) };
// 系统设置-获取角色(all)
export const getRoleAll = (params) => { return req("post", "/admin/admin/getRoleAll", params) };
// 我的线索
export const getMyClue = (params) => { return req("post", "/admin/clue/getMyClue", params) };
// 线索管理列表
export const getManageClue = (params) => { return req("post", "/admin/clue/getManageClue", params) };
// 添加线索
export const addClue = (params) => { return req("post", "/admin/clue/addClue", params) };
// 编辑线索
export const editClue = (params) => { return req("post", "/admin/clue/editClue", params) };
// 获取线索详情
export const getMyClueInfo = (params) => { return req("post", "/admin/clue/getMyClueInfo", params) };
// 添加线索跟进记录
export const addClueContact = (params) => { return req("post", "/admin/clue/addClueContact", params) };
// 线索管理-删除线索(勾选)
export const delCheckClue = (params) => { return req("post", "/admin/clue/delCheckClue", params) };
// 线索管理-删除线索(单个)
export const delMyClue = (params) => { return req("post", "/admin/clue/delMyClue", params) };
// 线索管理-修改线索手机号
export const updateClueMobile = (params) => { return req("post", "/admin/clue/updateClueMobile", params) };
// 导出(下载)线索(满足条件的线索)
export const exportClue = (params) => { return req("post", "/admin/clue/exportClue", params) };
// 添加线索-手机号查重
export const searchRepeatMobile = (params) => { return req("post", "/admin/clue/searchRepeatMobile", params) };
// 项目列表
export const getProject = (params) => { return req("post", "/admin/project/getProjectPageList", params) };
// 编辑项目
export const editProject = (params) => { return req("post", "/admin/project/editProject", params) };
// 删除项目
export const delProject = (params) => { return req("post", "/admin/project/delProject", params) };
// 删除项目(勾选)
export const delProjectCheck = (params) => { return req("post", "/admin/project/delProjectCheck", params) };
// 项目中心-合同删除
export const delAnnex = (params) => { return req("post", "/admin/project/delAnnex", params) };
// 导出勾选项目
export const downloadProject = (params) => { return req("post", "/admin/project/downloadProject", params) };
// 获取项目导入模板
export const getImportProjectExcel = (params) => { return req("post", "/admin/project/getImportProjectExcel", params) };
// 客户列表
export const getCustomerList = (params) => { return req("post", "/admin/customer/getCustomerList", params) };
// 我的客户列表
export const getMyCustomerList = (params) => { return req("post", "/admin/customer/getMyCustomerList", params) };
// 添加客户
export const addCustomer = (params) => { return req("post", "/admin/customer/addCustomer", params) };
// 管理添加客户
export const adminAddCustomer = (params) => { return req("post", "/admin/customer/adminAddCustomer", params) };
// 编辑客户
export const editCustomer = (params) => { return req("post", "/admin/customer/editCustomer", params) };
// 获取客户动作和案件
export const getCustomerAction = (params) => { return req("post", "/admin/customer/getCustomerActionAndCase", params) };
// 客户分配(勾选批量)
export const distributeCustomerCheck = (params) => { return req("post", "/admin/customer/distributeCustomerCheck", params) };
// 客户删除(勾选批量)
export const deleteCustomerCheck = (params) => { return req("post", "/admin/customer/deleteCustomerCheck", params) };
// 获取意向客户
export const getCustomerIntention = (params) => { return req("post", "/admin/customer/getCustomerIntention", params) };
// 获取客户公海
export const getCustomerPool = (params) => { return req("post", "/admin/customer/getCustomerPool", params) };
// 恢复客户公海数据(误将客户移入公海)
export const recoveryCustomer = (params) => { return req("post", "/admin/customer/recoveryCustomer", params) };
// 客户公海分配客户
export const allocationPool = (params) => { return req("post", "/admin/customer/allocationPool", params) };
// 客户列表-客户联系人列表
export const getCustomerContacts = (params) => { return req("post", "/admin/customer/getCustomerContacts", params) };
// 客户列表-添加客户联系人
export const addCustomerContacts = (params) => { return req("post", "/admin/customer/addCustomerContacts", params) };
// 客户列表-删除客户联系人
export const delCustomerContacts = (params) => { return req("post", "/admin/customer/delCustomerContacts", params) };
// 客户列表-客户发明人列表
export const getCustomerInventors = (params) => { return req("post", "/admin/customer/getCustomerInventors", params) };
// 客户列表-编辑客户发明人
export const editCustomerInventors = (params) => { return req("post", "/admin/customer/editCustomerInventors", params) };
// 客户列表-删除客户发明人
export const delCustomerInventors = (params) => { return req("post", "/admin/customer/delCustomerInventors", params) };
// 获取客户类型
export const getCustomerTypeList = (params) => { return req("post", "/admin/customer/getCustomerTypeList", params) };
// 获取商务列表(客户查询)
export const getSearchSeller = (params) => { return req("post", "/admin/customer/getSearchSeller", params) };
// 获取客户分配商户列表
export const getDistributeSeller = (params) => { return req("post", "/admin/customer/getDistributeSeller", params) };
// 客户下载(下载满足条件的数据)
export const downloadCustomerSearch = (params) => { return req("post", "/admin/customer/downloadCustomerSearch", params) };
// 获取案件列表
export const getCaseList = (params) => { return req("post", "/admin/cases/getCasePageList", params) };
// 获取文档列表
export const getDocList = (params) => { return req("post", "/admin/doc/getDocList", params) };
// 文档编辑
export const editDoc = (params) => { return req("post", "/admin/doc/editDoc", params) };
// 下载文档
export const loadDoc = (params) => { return req("post", "/admin/doc/loadDoc", params) };
// 删除文档
export const delDoc = (params) => { return req("post", "/admin/doc/delDoc", params) };
// 删除文档(勾选)
export const delCheckDoc = (params) => { return req("post", "/admin/doc/delCheckDoc", params) };
// 查询数据字典
export const getDictCate = (params) => { return req("post", "/admin/dict/getDictCate", params) };
// 部门列表
export const getDepartmentList = (params) => { return req("post", "/admin/department/getDepartmentList", params) };
// 数据字典列表
export const getDictList = (params) => { return req("post", "/admin/dict/getDictList", params) };
// 编辑数据字典
export const editDict = (params) => { return req("post", "/admin/dict/editDict", params) };
// 删除数据字典
export const delDict = (params) => { return req("post", "/admin/dict/delDict", params) };
// 查询所有部门(下拉框)
export const getDepartmentArr = (params) => { return req("post", "/admin/department/getDepartmentArr", params) };
// 部门编辑
export const editDepartment = (params) => { return req("post", "/admin/department/editDepartment", params) };
// 部门删除
export const delDepartment = (params) => { return req("post", "/admin/department/delDepartment", params) };
// 案件管理-获取商户列表(下拉框)
export const getAuthAdmin = (params) => { return req("post", "/admin/cases/getAuthAdmin", params) };
// 案件管理-获取客户列表(下拉框)
export const getAuthCustomer = (params) => { return req("post", "/admin/cases/getAuthCustomer", params) };
// 数据榜单-获取数据榜单
export const getRankData = (params) => { return req("post", "/admin/rank/getRankData", params) };
// 客户中心-客户查重
export const searchRepeatCustomer = (params) => { return req("post", "/admin/customer/searchRepeat", params) };
// 业绩中心-案件编辑
export const editCaseData = (params) => { return req("post", "/admin/cases/editCaseData", params) };
// 业绩中心-查询案件回款
export const getCaseCollection = (params) => { return req("post", "/admin/cases/getCaseCollection", params) };
// 业绩中心-添加回款信息
export const addCollection = (params) => { return req("post", "/admin/cases/addCollection", params) };
// 业绩中心-添加案件
export const addCaseData = (params) => { return req("post", "/admin/cases/addCaseData", params) };
// 业绩中心-删除案件
export const delCaseCheck = (params) => { return req("post", "/admin/cases/delCaseCheck", params) };
// 业绩中心-案件修改申请(已完成状态)
export const addApplyCase = (params) => { return req("post", "/admin/cases/addApplyCase", params) };
// 业绩中心-案件分配
export const distributeCheckCase = (params) => { return req("post", "/admin/cases/distributeCheckCase", params) };
// 业绩中心-我的案件列表
export const myCaseList = (params) => { return req("post", "/admin/cases/myCaseList", params) };
// 业绩中心-案件管理列表
export const caseManageList = (params) => { return req("post", "/admin/cases/caseManageList", params) };
// 业绩中心-审核结算列表
export const settAuditList = (params) => { return req("post", "/admin/cases/getAuditList", params) };
// 业绩中心-提交结算申请
export const applySett = (params) => { return req("post", "/admin/cases/applySett", params) };
// 业绩中心-结算申请审核
export const audit = (params) => { return req("post", "/admin/cases/audit", params) };
// 业绩中心-我的案件编辑
export const editMyCaseData = (params) => { return req("post", "/admin/cases/editMyCaseData", params) };
// 获取业务类型(委托事宜)
export const getEntrustList = (params) => { return req("post", "/admin/cases/getEntrustList", params) };
// 获取案件上报端口
export const getCasePortList = (params) => { return req("post", "/admin/cases/getCasePortList", params) };
// 案件导出(满足查询条件的案件)
export const downloadSearchCase = (params) => { return req("post", "/admin/cases/downloadSearchCase", params) };
// 个人中心-查询账户信息
export const getAdminInfo = (params) => { return req("post", "/admin/admin/getAdminInfo", params) };
// 个人中心-修改账户密码
export const resetPassword = (params) => { return req("post", "/admin/admin/resetPassword", params) };
// 消息通知-查询未读消息数量
export const getUnreadAdviceNum = (params) => { return req("post", "/admin/advice/getUnreadAdviceNum", params) };
// 消息通知-查询消息列表
export const getAdviceList = (params) => { return req("post", "/admin/advice/getAdviceList", params) };
// 消息通知-查询案件修改申请详情
export const getCaseApply = (params) => { return req("post", "/admin/advice/getCaseApply", params) };
// 消息通知-处理案件修改申请
export const verifyCaseApply = (params) => { return req("post", "/admin/advice/verifyCaseApply", params) };
// 消息通知-设置消息已读(单个已读)
export const setAdviceRead = (params) => { return req("post", "/admin/advice/setAdviceRead", params) };
// 消息通知-设置消息已读(全部已读)
export const setAllAdviceRead = (params) => { return req("post", "/admin/advice/setAllAdviceRead", params) };
// 客户中心-客户移入公海
export const customerMovePool = (params) => { return req("post", "/admin/customer/customerMovePool", params) };
// 财务中心-客户流水列表
export const getFinancePageList = (params) => { return req("post", "/admin/finance/getFinancePageList", params) };
// 财务中心-列表
export const getFinanceCustomerList = (params) => { return req("post", "/admin/finance/getFinanceCustomerList", params) };
// 财务中心-编辑客户流水
export const editFinance = (params) => { return req("post", "/admin/finance/editFinance", params) };
// 财务中心-删除客户流水
export const delFinance = (params) => { return req("post", "/admin/finance/delFinance", params) };
// 财务中心-上移客户流水
export const moveUpFinance = (params) => { return req("post", "/admin/finance/moveUpFinance", params) };
// 财务中心-下移客户流水
export const moveDownFinance = (params) => { return req("post", "/admin/finance/moveDownFinance", params) };
// 财务中心-插入客户流水
export const insertFinance = (params) => { return req("post", "/admin/finance/insertFinance", params) };
// 财务中心-标记流水记录
export const editFinanceMark = (params) => { return req("post", "/admin/finance/editFinanceMark", params) };
// 客户中心-查询客户流水和案件
export const getCustomerFinanceAndCase = (params) => { return req("post", "/admin/finance/getCustomerFinanceAndCase", params) };
// 客户中心-查询客户流水
export const getCustomerFinance = (params) => { return req("post", "/admin/finance/getCustomerFinance", params) };
// 财务中心-查询客户流水余额
export const getFinanceCustomerBalance = (params) => { return req("post", "/admin/finance/getFinanceCustomerBalance", params) };
// 财务中心-查询收付款单位数据
export const getPayeePayer = (params) => { return req("post", "/admin/finance/getPayeePayer", params) };
// 财务中心-导出客户流失记录
export const exportFinance = (params) => { return req("post", "/admin/finance/exportFinance", params) };
// 财务中心-修改流水记录
export const changeFinance = (params) => { return req("post", "/admin/finance/changeFinance", params) };
// 财务中心-移动流水记录(移动到第一条)
export const moveFinance = (params) => { return req("post", "/admin/finance/moveFinance", params) };





// export const webUrl = 'http://qzhip.crm.test/index.php/';
export const webUrl = 'https://crmapi.qzhip.com/index.php/';





// WEBPACK FOOTER //
// ./src/api/crmMG.js